import { getActionTypes } from '../../../HelperMethods/UtilityFunctions';

const types = getActionTypes('formManagement')([
  'SET_LOADER',
  'LOAD_FORMS',
  'UPSERT_FORM',
  'DELETE_FORM',
  'LOAD_PICKLISTS',
]);

export function loadForms(forms) {
  return { type: types.LOAD_FORMS, forms };
}

export function loadPickLists(pickLists) {
  return { type: types.LOAD_PICKLISTS, pickLists };
}

export function setLoader(loader) {
  return { type: types.SET_LOADER, loader };
}

export function upsertForm(form) {
  return { type: types.UPSERT_FORM, form };
}

export function deleteForm(form) {
  return { type: types.DELETE_FORM, formId: form.id };
}

export default function formReducer(state = { isFormPageLoading: true, forms: [], pickLists: [] }, action) {
  switch (action.type) {
    case types.SET_LOADER: {
      return { ...state, isFormPageLoading: action.loader };
    }
    case types.LOAD_FORMS: {
      return { ...state, forms: action.forms };
    }
    case types.LOAD_PICKLISTS: {
      return { ...state, pickLists: action.pickLists };
    }
    case types.DELETE_FORM: {
      return {
        ...state,
        forms: state.forms.filter(({ id: formId }) => formId !== action.formId),
      };
    }
    case types.UPSERT_FORM: {
      const { form } = action;
      return {
        ...state,
        forms: [...state.forms.filter(({ id: formId }) => formId !== form.id), form],
        isFormPageLoading: false,
      };
    }
    default:
      return state;
  }
}
